// src/composables/globalFunctions.ts
export interface GlobalFunctions {
  startLoading: () => void;
  endLoading: () => void;
  blockUI: () => void;
  unblockUI: () => void;
}

const gF = (): GlobalFunctions => {
  const startLoading = () => {
    window.dispatchEvent(new CustomEvent('start-loading'));
  };

  const endLoading = () => {
    window.dispatchEvent(new CustomEvent('stop-loading'));
  };

  const blockUI = () => {
    window.dispatchEvent(new CustomEvent('block-ui'));
  }

  const unblockUI = () => {
    window.dispatchEvent(new CustomEvent('unblock-ui'));
  };


  return {
    startLoading,
    endLoading,
    blockUI,
    unblockUI,
  };
};

export default gF;
